import _ from 'lodash'

/**
 * Handle tracking sorting between the 3 possible states in our API.  The first
 * state sets the sort ascending, the second state set the sort as descending
 * and the third state remove the sort.
 */
export default class SortToggler {

	/**
	 * Creates the Sort Toggler
	 * @param {String} [opts.sortField=null] - initialize the toggler with the
	 * given sort field
	 * @param {Boolean} [opts.ascending=null] - intialize the toggler with the
	 * given sort direction
	 * @param {Function} [init=_.noop] - callback for extra state initialization
	 */
	constructor(opts = {sortField: null, ascending: null}, init = _.noop) {
		this._state = { sortField: opts.sortField, ascending: opts.ascending }
		init(this._state)
 	}

 	state () {
 		return _.clone(this._state)
 	}

 	/**
 	 * Toggles the sort state by a given field, returns the sort properties of
 	 * the toggled state using the object defined as :
 	 * {sortField: [fieldName], ascending: [true|false]}
	 *
	 * @param { Object} [sortField=null] - toggles the sort state using the given
	 * field name. If null or nothing is passed in, the sort state is unset
	 * @return {Object} - returns the sort properties that represent the sort
	 * state or null if state did not change
 	 */
	toggle (obj = {}) {
		obj.sortField = obj.sortField || null
		//if null, unset the sort
		if (obj.sortField === null) {
			this._state = { sortField: null, ascending: null }
			return this.state()
		}

		//if directly assigning ascending skip toggle logic
		if (!_.isNil(obj.ascending)) {
			this._state = obj
			return this.state()
		}

		let currentState = this._state

		// check if toggling on same field, omits direction when comparing because
		// the toggler handles the directionality
		if (!_.isEqual(obj, _.omit(currentState, 'ascending'))) {
			this._state = _.assign({ ascending: true }, obj)
		} else if (this._state.ascending) {
			this._state = _.assign({ ascending: false }, obj)
		} else {
			this._state = _.assign(obj, { sortField: null, ascending: null })
		}
		return this.state()
	}

}
